import React, {ReactNode} from 'react';
import {FormikContextType, useFormikContext} from "formik";
import {classNames} from "../../../services/string";

const smallWidthClasses = [
    'sm:col-span-1',
    'sm:col-span-2',
    'sm:col-span-3',
    'sm:col-span-4',
    'sm:col-span-5',
    'sm:col-span-6',
    'sm:col-span-7',
    'sm:col-span-8',
    'sm:col-span-9',
    'sm:col-span-10',
    'sm:col-span-11',
    'sm:col-span-12',
]

const largeWidthClasses = [
    'lg:col-span-1',
    'lg:col-span-2',
    'lg:col-span-3',
    'lg:col-span-4',
    'lg:col-span-5',
    'lg:col-span-6',
    'lg:col-span-7',
    'lg:col-span-8',
    'lg:col-span-9',
    'lg:col-span-10',
    'lg:col-span-11',
    'lg:col-span-12',
]

const extraLargeWidthClasses = [
    'xl:col-span-1',
    'xl:col-span-2',
    'xl:col-span-3',
    'xl:col-span-4',
    'xl:col-span-5',
    'xl:col-span-6',
    'xl:col-span-7',
    'xl:col-span-8',
    'xl:col-span-9',
    'xl:col-span-10',
    'xl:col-span-11',
    'xl:col-span-12',
]

// Component ----

export type FormBlockProps = {
    columns?: number
    largeColumns?: number
    extraLargeColumns?: number
    children?: ReactNode | ((form: FormikContextType<any>) => any)
}

function FormBlock({columns, largeColumns, extraLargeColumns, children}: FormBlockProps) {
    const form = useFormikContext()

    const smallColumnIndex = Math.max(Number(columns) - 1, 0)
    const largeColumnIndex = largeColumns ? Math.max(Number(largeColumns) - 1, 0) : null
    const extraLargeColumnIndex = extraLargeColumns ? Math.max(Number(extraLargeColumns) - 1, 0) : null

    return (
        <div className={classNames(
            smallWidthClasses[smallColumnIndex],
            !!largeColumnIndex && largeWidthClasses[largeColumnIndex],
            !!extraLargeColumnIndex && extraLargeWidthClasses[extraLargeColumnIndex],
        )}>
            {typeof children === 'function'? children(form) : children}
        </div>
    );
}

export default FormBlock;